// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import RequestSummarySectionSchema from './request-summary-section-schema';

const schema = {
  $id: '/request-summary-schema',
  type: 'object',
  required: [],
  properties: {
    sections: {
      type: 'array',
      nullable: true,
      items: { ...RequestSummarySectionSchema },
    },
    languageIso2: {
      type: 'string',
      nullable: true,
    },
    subject: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
